module.exports = __webpack_public_path__ + "static/media/half_cloud.e0802d04.png";